// src/components/settings/SeoSettings.jsx
import React, { useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";

export default function SeoSettings() {
  const [ogImage, setOgImage] = useState(null);

  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setOgImage(URL.createObjectURL(file));
    }
  };

  return (
    <div className="seo-settings">
      <h5 className="mb-3">SEO Settings</h5>

      <div className="section-border">
        <Row>
          {/* Meta Title */}
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>Meta Title</Form.Label>
              <Form.Control />
            </Form.Group>
          </Col>

          {/* Meta Keywords */}
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>Meta Keywords</Form.Label>
              <Form.Control />
            </Form.Group>
          </Col>

          {/* Meta Description */}
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>Meta Description</Form.Label>
              <Form.Control as="textarea" rows={4} />
            </Form.Group>
          </Col>

          {/* Canonical URL */}
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>Canonical Url</Form.Label>
              <Form.Control />
            </Form.Group>
          </Col>

          {/* OG Title */}
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>Og Title</Form.Label>
              <Form.Control />
            </Form.Group>
          </Col>

          {/* OG Description */}
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>Og Description</Form.Label>
              <Form.Control as="textarea" rows={3} />
            </Form.Group>
          </Col>

          {/* OG IMAGE */}
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>Og Image</Form.Label>

              <div className="upload-box">
                <div className="upload-preview">
                  {ogImage ? (
                    <img src={ogImage} alt="" />
                  ) : (
                    <span className="placeholder-icon">📷</span>
                  )}
                </div>

                <div className="upload-content">
                  <h6>OG Image</h6>
                  <p className="text-muted small">
                    Recommended image size is 40px x 40px
                  </p>

                  <div className="d-flex gap-2">
                    <label className="btn btn-sm btn-orange mb-0">
                      Upload
                      <input
                        type="file"
                        hidden
                        onChange={handleUpload}
                      />
                    </label>

                    <Button
                      size="sm"
                      variant="light"
                      onClick={() => setOgImage(null)}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              </div>
            </Form.Group>
          </Col>
        </Row>

        {/* ACTION BUTTONS */}
        <div className="text-end mt-3">
          <Button variant="light">Cancel</Button>
          <Button className="btn-orange ms-2">Save</Button>
        </div>
      </div>
      <style>
          {
               `
               .seo-settings .section-border {
  border: 1px solid #e5e7eb;
  padding: 20px;
  border-radius: 6px;
  background: #fff;
}

.upload-box {
  display: flex;
  gap: 15px;
  border: 1px solid #eee;
  padding: 15px;
  border-radius: 6px;
  background: #fafafa;
  align-items: center;
}

.upload-preview {
  width: 70px;
  height: 70px;
  border: 1px dashed #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}

.upload-preview img {
  max-width: 100%;
  max-height: 100%;
}

.placeholder-icon {
  font-size: 20px;
  color: #aaa;
}

.upload-content h6 {
  margin-bottom: 4px;
  font-size: 14px;
}

.btn-orange {
  background: #ff6a00;
  border: none;
  color: #fff;
}

.btn-orange:hover {
  background: #e65c00;
}

.seo-settings input,
.seo-settings textarea {
  font-size: 14px;
}

/* MOBILE RESPONSIVE */
@media (max-width: 768px) {
  .upload-box {
    flex-direction: column;
    align-items: flex-start;
  }

  .upload-preview {
    width: 100%;
    height: 80px;
  }
}`
          }
      </style>
    </div>
  );
}